import { render, staticRenderFns } from "./basic-level-platform.vue?vue&type=template&id=4845e1d0&scoped=true&"
import script from "./basic-level-platform.vue?vue&type=script&lang=ts&"
export * from "./basic-level-platform.vue?vue&type=script&lang=ts&"
import style0 from "./basic-level-platform.vue?vue&type=style&index=0&id=4845e1d0&prod&lang=scss&scoped=true&"
import style1 from "./basic-level-platform.vue?vue&type=style&index=1&id=4845e1d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4845e1d0",
  null
  
)

export default component.exports